<style scoped lang="less">
  .statistics {
    margin-bottom: 10px;

    label {
      font-weight: 600;
    }
  }
</style>
<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>财务管理</Breadcrumb-item>
        <Breadcrumb-item>退费列表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div style="margin-top: 20px">
      <Row>
        <i-col :md="4">
          待审核金额: <label>{{statistics.waitAuditNum}}</label>
        </i-col>
        <i-col :md="4">
          待退金额: <label>{{statistics.waitRefundNum}}</label>
        </i-col>
        <i-col :md="4">
          已退费金额: <label>{{statistics.refundNum}}</label>
        </i-col>
      </Row>
      <Form style="margin-top: 15px" :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="16">
        <Col :span="6">
          <Form-item label="状态">
            <Select v-model="queryParam.status" placeholder="请选择" clearable @on-change="search">
              <Option value="0">待审核</Option>
              <Option value="1">已审核</Option>
              <Option value="2">已退费</Option>
              <Option value="3">驳回</Option>
              <Option value="9">劝退成功</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="发票">
            <Select v-model="queryParam.invoiceState" placeholder="请选择" clearable @on-change="search">
              <Option value="2">未开票</Option>
              <Option value="1">需回收</Option>
              <Option value="2">已回收</Option>
            </Select>
          </Form-item>
        </Col>
          <Col span="6">
            <Form-item label="学员id" prop="nickname">
              <Input v-model="queryParam.uid"></Input>
            </Form-item>
          </Col>
          <Col span="6">
            <Form-item label="申请人" prop="nickname">
              <Input placeholder="支持模糊搜索" v-model="queryParam.applyName"></Input>
            </Form-item>
          </Col>
          <Col span="6">
            <Form-item label="订单Id" prop="orderId">
              <Input placeholder="支持模糊搜索" v-model="queryParam.orderId"></Input>
            </Form-item>
          </Col>
          <Col :span="8">
        <Form-item label="申请时间">
          <Row>
            <Col :span="11">
            <Date-picker
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              placeholder="请选择日期"
              @on-change="startTimeDateChange"
              style="width: 100%;"
              v-model="queryParam.startTimeDate">
            </Date-picker>
          </Col>
          <Col span="1" style="text-align: center">-</Col>
          <Col :span="11">
            <Date-picker
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              placeholder="请选择日期"
              @on-change="endTimeDateChange"
              style="width: 100%;"
              v-model="queryParam.endTimeDate">
          </Date-picker>
          </Col>
        </Row>
        </Form-item>
        </Col>
          <Col span="6">
            <Button style="margin-left: 10px" type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                    @click="search">搜索
            </Button>
            <Button style="margin-left: 10px" type="warning" :loading="searchLoading" :disable="searchLoading" icon="nuclear"
                    @click="showInsertRefundModal">申请退费
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <div style="margin-top: 10px">
    <List ref="dataList" :reload="reload" :params="queryParam" :tableColumns="title" listUrl="/financial/refund/list" :onLoading="onLoading"></List>
    </div>
    <refund-insert-modal :id="id" :orderNum="orderId" :value="refundInsertModal" :canSave="canSave" @on-close="onRefundInsertClose" :successCallback="search"></refund-insert-modal>
  </div>
</template>
<script>
  import RefundInsertModal from './modal/RefundInsertModal.vue'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
  export default {
    components: {
      RefundInsertModal,
    },
    data () {
      let $constant = this.$constant
      let $moment = this.$moment
      return {
        startTime: '',
        endTime: '',
        statistics: {
          waitAuditNum: 0,
          waitRefundNum: 0,
          refundNum: 0
        },
        searchLoading: false,
        refundInsertModal: false,
        id: null,
        canSave: true,
        reload: 0,
      rankScoreSeq: 0,
        orderId: '',
        queryParam: {
          uid: '',
          applyName: '',
          invoiceState: '',
          status: '',
          startTime: '',
          endTime: '',
          orderId: ''
        },
        title: [
          {
            title: '学生ID/姓名',
            width: 150,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.uid + '-' + row.nickName)
            }
          },
          {
            title: '付款日期',
            width: 170,
            align: 'center',
            render: (h, params) => {
              let payTime = params.row.payTime
              if (payTime === 0) {
                return
              }
              return h('span', payTime && $moment(payTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            title: '订单ID',
            key: 'orderId',
            width: 130,
            align: 'center',
          },
          {
            title: '退款原因分类',
            width: 120,
            align: 'center',
            render: (h, params) => {
              let statusEnum = $constant.getEnum($constant.refundReasonCategory, params.row.refundReasonCategory)
              return h('span', statusEnum && statusEnum.text)
            }
          },
          {
            title: '订单金额',
            width: 100,
            align: 'center',
            key: 'fundAmount'
          },
          {
            title: '消耗',
            width: 100,
            align: 'center',
            key: 'costAmount'
          },
          {
            title: '教材金额',
            width: 100,
            align: 'center',
            key: 'textAmount'
          },
          {
            title: '其他扣款',
            width: 100,
            align: 'center',
            key: 'otherAmount'
          },
          {
            title: '课时单价',
            width: 100,
            align: 'center',
            key: 'courseUnitPrice'
          },
          {
            title: '课时费',
            width: 100,
            align: 'center',
            key: 'lessonFee'
          },
          {
            title: '礼品费',
            width: 100,
            align: 'center',
            key: 'giftFee'
          },
          {
            title: '手续费',
            width: 100,
            align: 'center',
            key: 'serviceFee'
          },
          {
            title: '实际退款金额',
            width: 120,
            align: 'center',
            key: 'actualRefundAmount'
          },
          {
            title: '最后一节课老师',
            width: 180,
            align: 'center',
            key: 'lastTchName',
            render: (h, params) => {
              let row = params.row
              return renderTchNameWithScore(h, {
                text: row.lastTchName,
                score: row.monthRankScore
              })
            }
          },
          {
            title: '对应老师外管',
            width: 120,
            align: 'center',
            key: 'tchAdviserName'
          },
          {
            title: '注册渠道',
            width: 120,
            align: 'center',
            key: 'regChannel'
          },
          {
            title: '退费金额',
            width: 100,
            align: 'center',
            key: 'refundAmount'
          },
          {
            title: '发票',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let statusEnum = $constant.getEnum($constant.refundInvoice, params.row.invoiceState)
              return h('span', statusEnum && statusEnum.text)
            }
          },
          {
            title: '申请人',
            width: 100,
            align: 'center',
            key: 'applyName'
          },
          {
            title: '申请时间',
            width: 170,
            align: 'center',
            render: (h, params) => {
              let applyTime = params.row.applyTime
              if (applyTime === 0) {
                return
              }
              return h('span', applyTime && $moment(applyTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            title: '状态',
            width: 130,
            align: 'center',
            render: (h, params) => {
              let statusEnum = $constant.getEnum($constant.refundState, params.row.status)
              return h('span', statusEnum && statusEnum.text)
            }
          },
          {
            title: '审核时间',
            width: 170,
            align: 'center',
            render: (h, params) => {
              let auditTime = params.row.auditTime
              if (auditTime === 0) {
                return
              }
              return h('span', auditTime && $moment(auditTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            title: '操作',
            width: 100,
            align: 'center',
            fixed: 'right',
            render: (h, params) => {
              let row = params.row
              let btn = []
              btn.push(h('Dropdown-item', { props: { name: 'show' } }, '查看'))
              btn.push(h('Dropdown-item', { props: { name: 'reBack' } }, '劝退成功'))
              btn.push(h('Dropdown-item', { props: { name: 'pass' } }, '通过'))
              btn.push(h('Dropdown-item', { props: { name: 'reject' } }, '驳回'))
              btn.push(h('Dropdown-item', { props: { name: 'recieveInvoice' } }, '收到发票'))
              btn.push(h('Dropdown-item', { props: { name: 'refund' } }, '已退款'))

              return h('div', [
                h('Dropdown', {
                  props: {
                    transfer: true,
                    trigger: 'click',
                  },
                  on: {
                    'on-click': (name) => {
                      if (name === 'show') {
                        this.id = parseInt(row.id)
                        this.orderId = row.orderId
                        this.canSave = false
                        this.refundInsertModal = true
                      } else if (name === 'reBack') {
                        this.reBack(row.id)
                      } else if (name === 'pass') {
                        this.audit(row.id)
                      } else if (name === 'reject') {
                        this.reject(row.id)
                      } else if (name === 'recieveInvoice') {
                        this.recieveInvoice(row.id)
                      } else if (name === 'refund') {
                        this.refund(row.id)
                      }
                    }
                  }
                }, [
                  h('a', [
                    h('span', '更多 '),
                    h('Icon', {props: {type: 'ios-arrow-down'}})
                  ]),
                  h('Dropdown-menu', {slot: 'list'}, btn)
                ]),
              ])
            }
          },
        ]
      }
    },
    mounted: function () {
    },
    created: function () {
      let self = this
      self.$http.get('/financial/refund/statistics/list', {silent: true}).then(function (res) {
        if (res && res.status === 'ok' && res.data && typeof res.data === 'object') {
          self.statistics = res.data
        }
      })
    },
    watch: {
    },
    methods: {
    onLoading (loading) {
      if (!loading) {
        this.loadMonthRankScores()
      }
    },
    loadMonthRankScores () {
      const table = this.$refs.dataList && this.$refs.dataList.tableData
      if (!table || !table.length) {
        return
      }
      const ids = table.map(function (row) { return row.lastTchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, table, 'lastTchId', 'monthRankScore', map)
      })
    },

/*      init () {
        let query = this.$route.query
        if (query) {
          uid: '',
            applyName: '',
            invoiceState: '',
            status: '',
            startTime: '',
            endTime: '',
            orderId: ''
          if (query.uid) {
            this.queryParam.uid = query.uid
            this.queryParam.applyName = query.applyName
            this.queryParam.invoiceState = query.invoiceState
            this.queryParam.status = query.status
            this.queryParam.startTime = query.startTime
            this.queryParam
          }
        }
      },
      */
      reject (id) {
        let self = this
        self.$http.post('/financial/refund/reject', {id: id}).then(function (res) {
          if (res.data && res.data > 0) {
            self.$Message.success('驳回成功!')
            self.search()
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
      recieveInvoice (id) {
        let self = this
        self.$http.post('/financial/refund/receiveInvoice', {id: id}).then(function (res) {
          if (res.data && res.data > 0) {
            self.$Message.success('回收发票成功!')
            self.search()
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
      refund (id) {
        let self = this
        self.$Modal.confirm({
          title: '提示',
          content: '确认将该退费标记为已退款？',
          onOk: () => {
            self.$http.post('/financial/refund/financePass', {id: id}).then(function (res) {
              if (res.data && res.data > 0) {
                self.$Message.success('退费成功!')
                self.search()
              } else {
                this.$Message.error(res.msg)
              }
            })
          }
        })
      },
      audit (id) {
        let self = this
        self.$http.post('/financial/refund/pass', {id: id}).then(function (res) {
          if (res.data && res.data > 0) {
            self.$Message.success('审核成功!')
            self.search()
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
      reBack (id) {
        let self = this
        self.$http.post('/financial/refund/reBack', {id: id}).then(function (res) {
          if (res.data && res.data > 0) {
            self.$Message.success('劝退成功!')
            self.search()
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
      showInsertRefundModal () {
        this.canSave = true
        this.refundInsertModal = true
      },
      onRefundInsertClose () {
        this.id = null
        this.refundInsertModal = false
      },
      startTimeDateChange (value) {
        this.queryParam.startTime = value
      },
      endTimeDateChange (value) {
        this.queryParam.endTime = value
      },
      search () {
        this.reload = new Date().getTime()
      },
    }
  }

</script>



// WEBPACK FOOTER //
// RefundList.vue?bfde6218